module.exports = __webpack_public_path__ + "static/media/1994925263645843_130.db24d7cb.jpg";